import { notify } from '../utils/notification'
import { parseError, agent, updateSessionObject } from 'utils/api'
import constants from 'constants'
import { push } from 'react-router-redux'
import { commonFunctions } from 'utils/CommonFunctions'

export const PARTNERPLAN_GET = 'PARTNERPLAN_GET'
export const PARTNERPLAN_RECEIVED = 'PARTNERPLAN_RECEIVED'
export const PARTNERPLAN_DOCUMENT_RECEIVED = 'PARTNERPLAN_DOCUMENT_RECEIVED'
export const PARTNERPLAN_CREATE_RECEIVED = 'PARTNERPLAN_CREATE_RECEIVED'
export const PARTNERPLAN_UPDATESTATUSES_RECEIVED = 'PARTNERPLAN_UPDATESTATUSES_RECEIVED'
export const PARTNERPLAN_REMINDEREMAIL_RECEIVED = 'PARTNERPLAN_REMINDEREMAIL_RECEIVED'
export const PARTNERPLAN_DOCUMENT_DELETE_RECEIVED = 'PARTNERPLAN_DOCUMENT_DELETE_RECEIVED'
export const PARTNERPLAN_DOCUMENT_DELETE_COMPLETE = 'PARTNERPLAN_DOCUMENT_DELETE_COMPLETE'
export const PARTNERPLAN_GET_ERROR = 'PARTNERPLAN_GET_ERROR'

const deleteDocumentRequest = () => ({
  type: PARTNERPLAN_DOCUMENT_DELETE_RECEIVED,
})

const partnerPlanCreateReceived = () => ({
  type: PARTNERPLAN_CREATE_RECEIVED,
})

const partnerPlanUpdateStatusesReceived = () => ({
  type: PARTNERPLAN_UPDATESTATUSES_RECEIVED,
})

const deleteDocumentComplete = result => ({
  result,
  type: PARTNERPLAN_DOCUMENT_DELETE_COMPLETE,
})

const fetching = type => ({
  type,
})

const fetchingerror = type => ({
  type,
})

const partnerPlanReceive = partnerPlan => ({
  type: PARTNERPLAN_RECEIVED,
  partnerPlan,
})

const partnerPlanDocumentsReceive = partnerPlanDocuments => ({
  type: PARTNERPLAN_DOCUMENT_RECEIVED,
  partnerPlanDocuments,
})

const partnerPlanReminderEmailReceive = partnerPlanEmailReminder => ({
  type: PARTNERPLAN_REMINDEREMAIL_RECEIVED,
  partnerPlanEmailReminder,
})

const allowDelete = (planStatus, documentType) => {
  switch (planStatus) {
    case constants.PARTNERPLAN.STATUS.DRAFT:
    case constants.PARTNERPLAN.STATUS.UPLOADED:
    case constants.PARTNERPLAN.STATUS.SUBMITTED:
    case constants.PARTNERPLAN.STATUS.AGREED:
    case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT:
    case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_SUBMITTED:
      return (documentType === constants.PARTNERPLAN.DOCUMENTTYPE.INTERIM)
    case constants.PARTNERPLAN.STATUS.INTERIM_ASSESSMENT_AGREED:
    case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT:
    case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_SUBMITTED:
      return (documentType === constants.PARTNERPLAN.DOCUMENTTYPE.FINAL)
    case constants.PARTNERPLAN.STATUS.FINAL_ASSESSMENT_AGREED:
      return false
    default:
      return false
  }
}

const mapPartnerPlanDocs = (result, planStatus, role) => {
  const partnerPlanDocuments = result.map(plan => ({
    itemId: plan.ItemID,
    employeeId: plan.EmployeeId,
    loginName: plan.UserName,
    documentType: plan.DocumentType,
    year: plan.Year,
    planStatus: (planStatus || plan.Status),
    name: commonFunctions.trimString(plan.Name, constants.PARTNERPLAN.MAX_FILENAME_LENGHT),
    documentName: plan.Name,
    documentTag: `${(plan.Name.length >= 10 ? plan.Name.substring(0, 9) : plan.Name)}${(plan.DocumentType === constants.PARTNERPLAN.DOCUMENTTYPE.INTERIM
      ? constants.PARTNERPLAN.DOCUMENTPREFIX.INTERIM
      : commonFunctions.iff(
        (plan.DocumentType === constants.PARTNERPLAN.DOCUMENTTYPE.FINAL),
        constants.PARTNERPLAN.DOCUMENTPREFIX.FINAL,
        constants.PARTNERPLAN.DOCUMENTPREFIX.PLAN,
      ))}`,
    uploadedDate: plan.Created,
    modifiedDate: plan.Modified,
    path: plan.URL,
    allowDelete: (role === constants.PARTNERPLAN.ROLE.MYPLANS ? allowDelete((planStatus || plan.Status), plan.DocumentType) : false),
  }))
  // const planDocumentsSorted = partnerPlanDocuments.sort((a, b) => new Date(b.uploadedDate) - new Date(a.uploadedDate))
  // filter and only return the one latest interim and final assessment document (applies only to plan submitted via Neota logic)
  const uniqueInterimFinalDocs = []
  const planDocuments = partnerPlanDocuments.sort((a, b) => new Date(b.uploadedDate) - new Date(a.uploadedDate)).filter((element) => {
    const isDuplicate = uniqueInterimFinalDocs.includes(element.documentTag)
    if (!isDuplicate) {
      uniqueInterimFinalDocs.push(element.documentTag)
      return true
    }
    return false
  })

  return planDocuments
}

export function getPartnerPlan(employeeId, forEmployeeId, year) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_GET))
    agent.PartnerPlans.details(employeeId, forEmployeeId, year).then((response) => {
      let partnerPlan = {}
      if (response.length > 0) {
        partnerPlan = {
          rowId: response[0].rowId,
          employeeId: response[0].employee_id,
          loginName: response[0].loginname,
          name: response[0].partner_name.trim(),
          year: response[0].year,
          interimCounsellee: response[0].InterimCounsellee,
          interimCounselleeComments: response[0].InterimCounselleeComments,
          interimCounsellor: response[0].InterimCounsellor,
          interimCounsellorComments: response[0].InterimCounsellorComments,
          interimAgreedDate: response[0].InterimAgreedDate,
          finalCounselleeAssessment: response[0].FinalCounselleeAssessment,
          finalCounselleeComments: response[0].FinalCounselleeComments,
          finalCounsellorAssessment: response[0].FinalCounsellorAssessment,
          finalCounsellorComments: response[0].FinalCounsellorComments,
          finalAgreedDate: response[0].FinalAgreedDate,
          planStatus: response[0].PlanStatus,
          lastModifiedBy: response[0].LastModifiedBy,
          lastModifiedDate: response[0].LastModifiedDate,
          planAgreedDate: response[0].PlanAgreedDate,
          planSubmittedDate: response[0].PlanSubmittedDate,
          planUploadedDate: response[0].PlanUploadedDate,
          interimDate: response[0].InterimDate,
          finalDate: response[0].FinalDate,
          cpEmpId: response[0].Counselling_Partner_Employee_Id,
          cpEmail: response[0].Counselling_Partner_Email,
          cpName: response[0].Counselling_Partner_Name,
          mlEmpId: response[0].Market_Leader_Employee_Id,
          mlEmail: response[0].Market_Leader_Email,
          mlName: response[0].Market_Leader_Name,
          blEmpId: response[0].Business_Leader_Employee_Id,
          blEmail: response[0].Business_Leader_Email,
          blName: response[0].Business_Leader_Name,
          cilEmpId: response[0].Client_Industry_Leader_Employee_Id,
          cilEmail: response[0].Client_Industry_Leader_Email,
          cilName: response[0].Client_Industry_Leader_Name,
          bucooEmpId: response[0].Business_Coo_Employee_Id,
          bucooEmail: response[0].Business_Coo_Email,
          bucooName: response[0].Business_Coo_Name,
          olEmpId: response[0].Offering_Leader_Employee_Id,
          olEmail: response[0].Offering_Leader_Email,
          olName: response[0].Offering_Leader_Name,
          oplEmpId: response[0].Offering_Portfolio_Leader_Employee_Id,
          oplEmail: response[0].Offering_Portfolio_Leader_Email,
          oplName: response[0].Offering_Portfolio_Leader_Name,
          ceoEmpId: response[0].Ceo_Employee_Id,
          ceoEmail: response[0].Ceo_Email,
          ceoName: response[0].Ceo_Name,
          adminComments: response[0].AdminComments,
          planAgreedWithCounsellee: response[0].PlanAgreedWithCounsellee,
          interimPlanAgreedWithCounsellee: response[0].InterimPlanAgreedWithCounsellee,
          finalPlanAgreedWithCounsellee: response[0].FinalPlanAgreedWithCounsellee,
          finalAgreedInterimRating: response[0].FinalAgreedInterimRating,
          finalAgreedInterimComments: response[0].FinalAgreedInterimComments,
          finalAgreedInterimRatingSaved: response[0].FinalAgreedInterimRatingSaved,
          finalAgreedFinalRating: response[0].FinalAgreedFinalRating,
          finalAgreedFinalComments: response[0].FinalAgreedFinalComments,
          finalAgreedFinalRatingSaved: response[0].FinalAgreedFinalRatingSaved,
          businessUnit: response[0].BusinessUnit,
          interimRatingVisibility: response[0].InterimRatingVisibility,
          finalRatingVisibility: response[0].FinalRatingVisibility,
          assessmentFlag: response[0].AssessmentFlag,
        }
      }
      dispatch(partnerPlanReceive(partnerPlan))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerPlan>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_GET_ERROR))
      }
    })
  }
}

export function getPartnerPlanDocuments(employeeId, year, planStatus, role) {

  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_GET))
    agent.PartnerPlans.getplans(year, employeeId).then((response) => {
      dispatch(partnerPlanDocumentsReceive(mapPartnerPlanDocs(response, planStatus, role)))
      // dispatch(notify('Successfully load admin centre'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <getPartnerPlanDocuments>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_GET_ERROR))
      }
    })
  }
}

export function deletePartnerPlanDocument(itemId, employeeId, year, planStatus, role) {
  return (dispatch) => {
    dispatch(deleteDocumentRequest())
    agent.FileUploader.deleteplan(itemId, employeeId, year).then((response) => {
      dispatch(partnerPlanDocumentsReceive(mapPartnerPlanDocs(response, planStatus, role)))
      dispatch(notify('Partner plan document deleted'))
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <deletePartnerPlanDocument>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_GET_ERROR))
      }
    })
  }
}

export function createPartnerplanForFY(employeeId, year) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_GET))
    agent.PartnerPlans.createplansforfy(employeeId, year).then((response) => {
      if (response.length > 0) {
        if (response[0].num > 0) {
          dispatch(notify(`${response[0].num} ${response[0].message} for FY${year}`))
        } else {
          dispatch(notify(`No plans to create for FY${year}`))
        }
      }
      dispatch(partnerPlanCreateReceived)
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <createPartnerplanForFY>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_GET_ERROR))
      }
    })
  }
}

export function bulkUpdatePartnerPlanStatus(employeeId, year, planstatus, modifiedby) {
  return (dispatch) => {
    dispatch(fetching(PARTNERPLAN_GET))
    agent.PartnerPlans.updateplanstatuses(employeeId, year, planstatus, modifiedby).then((response) => {
      if (response.length > 0) {
        if (response[0].num > 0) {
          dispatch(notify(`${response[0].num} ${response[0].message} for FY${year}`))
        } else {
          dispatch(notify(`No plans to update to ${planstatus} for FY${year}`))
        }
      }
      dispatch(partnerPlanUpdateStatusesReceived)
    }).catch((rawError) => {
      const { error, status, description } = parseError(rawError)
      if (status === constants.ERROR.INTERNAL_SERVER || status === constants.ERROR.SERVICE_UNAVAILABLE) {
        dispatch(push({
          pathname: '/error',
          search: `?type=${constants.ERROR.INTERNAL_SERVER}`,
        }))
      } else if (status === constants.ERROR.UNAUTHORIZED) {
        updateSessionObject()
      } else {
        dispatch(notify(description))
        // console.warn('Err <bulkUpdatePartnerPlanStatus>: ', error)
        dispatch(fetchingerror(PARTNERPLAN_GET_ERROR))
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/partnerPlan.js